export const colors = {
  bg: '#0f172a',
  bgLight: '#131c31',
  sidebar: '#0c1222',
  card: '#1e293b',
  cardHover: '#334155',
  border: '#334155',
  borderLight: '#475569',
  primary: '#3b82f6',
  primaryDark: '#2563eb',
  primaryLight: '#60a5fa',
  success: '#10b981',
  successDark: '#059669',
  warning: '#f59e0b',
  warningDark: '#d97706',
  danger: '#ef4444',
  dangerDark: '#dc2626',
  info: '#06b6d4',
  infoDark: '#0891b2',
  text: '#f1f5f9',
  textMuted: '#94a3b8',
  textDim: '#64748b',
  white: '#ffffff',
};

export const fmt = (v) => {
  if (v === null || v === undefined) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
};

export const fmtNum = (v) => {
  if (v === null || v === undefined) return '0';
  return new Intl.NumberFormat('pt-BR').format(v);
};

export const faseColor = (fase) => {
  const map = {
    'NORMAL': colors.success, 'ATENÇÃO': colors.warning, 'ALTO': '#f97316',
    'URGENTE': colors.danger, 'CRÍTICO': colors.dangerDark, 'EM DIA': colors.success,
    'ATRASO <30': colors.warning, 'ATRASO 30-60': '#f97316', 'ATRASO 60-90': colors.danger,
    'ATRASO >90': colors.dangerDark, 'NEGOCIAÇÃO': colors.info, 'CANCELADO': colors.textDim
  };
  return map[fase] || colors.textMuted;
};

export const statusColor = (status) => {
  const map = {
    'ATIVO': colors.success, 'INATIVO': colors.warning, 'CANCELADO': colors.danger,
    'BLOQUEADO': colors.dangerDark, 'PAGO TOTAL': colors.success, 'PAGO MÍNIMO': colors.warning,
    'PAGO PARCIAL': '#f97316', 'NÃO PAGO': colors.danger, 'ACORDO': colors.info
  };
  return map[status] || colors.textMuted;
};

export const riscoColor = (risco) => {
  const map = { 'BAIXO': colors.success, 'MEDIO': colors.warning, 'ALTO': '#f97316', 'CRITICO': colors.dangerDark };
  return map[risco] || colors.textMuted;
};

export const escalacaoLabel = (nivel) => {
  const map = { 0: 'Nenhum', 1: 'SAC', 2: 'Ouvidoria', 3: 'Bacen', 4: 'Consumidor.gov', 5: 'Procon', 6: 'Reclame Aqui' };
  return map[nivel] || 'Desconhecido';
};

export const statusAcordoColor = (status) => {
  const map = { 'SEM_ACORDO': colors.textDim, 'EM_NEGOCIACAO': colors.info, 'PENDENTE': colors.warning, 'ACEITO': colors.success, 'RECUSADO': colors.danger };
  return map[status] || colors.textMuted;
};

export const API = window.location.origin + '/api';

// Retorna o header Authorization com o token JWT do usuário logado
export function authHeaders(extra = {}) {
  const token = localStorage.getItem('xm_token');
  return token
    ? { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...extra }
    : { 'Content-Type': 'application/json', ...extra };
}

// Helper para construir URL com filtro de titular automatico.
// Quem tem OPERAÇÃO não recebe o titular_id fixo: o padrão passa a ser a
// operação inteira, e o seletor da tela é que restringe a um titular. O
// servidor valida o que vier (lib/escopo-titular) — isto aqui é conveniência.
export function apiUrl(path, params = {}) {
  const tid = getTitularId();
  if (tid && !temOperacao()) {
    params.titular_id = tid;
  }
  const url = new URL(`${window.location.origin}/api${path}`);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, v);
  });
  return url.toString();
}

// titular_id de restrição: só pra quem é restrito a um titular (vê só os
// próprios dados). Gestores (ADMIN/Gerente/Operador) NÃO são restritos, mesmo
// tendo titular_id vinculado — retorna null pra eles verem tudo.
export function getTitularId() {
  const usuario = JSON.parse(localStorage.getItem('xm_usuario') || '{}');
  if (!usuario.titular_id) return null;
  if (podeGerenciarCartoes()) return null;
  return usuario.titular_id;
}

// Operação: grupo de titulares que o usuário enxerga como um caixa só.
// Vazio quando o titular não pertence a nenhuma — aí vale o comportamento
// de sempre, um usuário → um titular.
export function getOperacao() {
  const usuario = JSON.parse(localStorage.getItem('xm_usuario') || '{}');
  return usuario.operacao || null;
}

export function getTitularesVisiveis() {
  const usuario = JSON.parse(localStorage.getItem('xm_usuario') || '{}');
  return Array.isArray(usuario.titulares_visiveis) ? usuario.titulares_visiveis : [];
}

export function temOperacao() {
  return getTitularesVisiveis().length > 1;
}

// Helper para verificar se o usuário logado é ADMIN
export function isAdmin() {
  const usuario = JSON.parse(localStorage.getItem('xm_usuario') || '{}');
  return Array.isArray(usuario.perfis) && usuario.perfis.includes('ADMIN');
}

// Quem enxerga cartão em NEGOCIAÇÃO. Espelha veNegociacao() do servidor
// (server/middleware/auth.js) — ADMIN ou quem tem a flag acesso_crise, que é
// quem opera os painéis de Crise. Aqui é só pra esconder botão/opção de filtro:
// o servidor é quem de fato não manda os cartões.
export function veNegociacao() {
  const usuario = JSON.parse(localStorage.getItem('xm_usuario') || '{}');
  const p = Array.isArray(usuario.perfis) ? usuario.perfis : [];
  return p.includes('ADMIN') || !!usuario.acesso_crise;
}

// Label de exibição da origem de um lançamento. O valor no banco continua
// 'XM_PRODUCAO' (a integração usa), mas pra usuário mostramos 'TechMiles'.
export function origemLabel(origem) {
  if (origem === 'XM_PRODUCAO') return 'TechMiles';
  return origem || 'N/A';
}

// Perfis de GESTÃO de cartões (veem ações admin: dedup, remover planilha,
// seleção em massa). Titular e demais perfis de visualização não veem.
export function podeGerenciarCartoes() {
  const usuario = JSON.parse(localStorage.getItem('xm_usuario') || '{}');
  const p = Array.isArray(usuario.perfis) ? usuario.perfis : [];
  return p.includes('ADMIN') || p.includes('Gerente Financeiro') || p.includes('Operador Financeiro');
}
